import { render } from "./TPAView.vue?vue&type=template&id=173c3f3c&scoped=true"
import script from "./TPAView.vue?vue&type=script&lang=js"
export * from "./TPAView.vue?vue&type=script&lang=js"

import "./TPAView.vue?vue&type=style&index=0&id=173c3f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173c3f3c"]])

export default __exports__